import React, { Component } from 'react';
import './projects.css';



class IndexThumb extends Component {
    constructor(){
        super();
        this.state = {
            data:[]
        }

    };


    componentDidMount(){

    }

  

   

    render() {
    const {item} = this.props;
    const {i} = this.props;
    const {hover} = this.props;
    const {image } = this.props;
    const {initPro} = this.props;
    return (
        
    
      <React.Fragment>
          
          <div key={`item-${i}`} className={`col3 indexThumb ratio${item.ratio}`}>
                    <div className="fullWidth fullHeight thumbHold"  onClick={initPro.bind(this)}>
                    <div className={`ratH ratio${item.ratio}`}></div>
                    {item.media.length?(
                        
                            item.media.map((pic,p)=>{
                                return(
                                        <div className={`indexImgHold viewImgHold fullWidth fullHeight indexImg ${(parseInt(hover)===parseInt(i))?"hover":""} ${image===p?"active":""}`}>
                                             <img  key={(parseInt(hover)===parseInt(i))?(`thumb-${i}+${image}`):(`thumb-${i}+${0}`)} className="imgCover" src={((parseInt(hover)===parseInt(i)) && image)?(this.props.getImg(item.media[image].name, 800)):(this.props.getImg(item.media[0].name, 800))} alt={`Still from "${this.props.titleCase(item.title)}", ${item.client?("for "+(this.props.titleCase(item.client))):('')} Directed by David M. Helman`}></img>
                                        </div>
                                
                                )
                            })
                        

                        
                    ):('')}
                </div>
            </div>

                

    
       </React.Fragment>
    
    );
  }
}

export default IndexThumb;



// WEBPACK FOOTER //
// ./src/components/projects/indexThumb.js